// src/routes/authRoutes.js
// Public pages — no login needed.
// Like GEMS's (auth)/ route group — login pages are separated from protected pages.

import { Route } from "react-router-dom";
import SignIn from "../pages/auth/signIn/page";
import NewPassword from "../pages/newpassword/newpassword";
import ResetPassword from "../pages/resetpassword/resetpassword";

const authRoutes = [
  <Route key="signin"        path="/"              element={<SignIn />} />,
  <Route key="newpassword"   path="/newpassword"   element={<NewPassword />} />,
  <Route key="resetpassword" path="/resetpassword" element={<ResetPassword />} />,
];

export default authRoutes;
